export const ADMIN_NAV_OPTIONS = [
  {
    name: "Registrations",
    path: "/admin/registrations",
    color: "#f2c4c4",
    icon: "fa-solid fa-clipboard-list",
    permission: "view_registrations",
  },
  {
    name: "Courses",
    path: "/admin/courses",
    color: "#f9e1be",
    icon: "fa-solid fa-book-open-reader",
    permission: "view_courses",
  },
  {
    name: "Attendance",
    path: "/admin/attendance",
    color: "#d5d1fd",
    icon: "fa-solid fa-clipboard-check",
    permission: "view_attendance",
  },
  {
    name: "Users",
    path: "/admin/users",
    color: "#bff1db",
    icon: "fa-solid fa-user-group",
    permission: "view_users",
  },
  {
    name: "Financial Aid",
    path: "/admin/financial-aid",
    color: "#d5d1fd",
    icon: "fa-solid fa-hand-holding-dollar",
    permission: "view_financial_aid",
  },
  {
    name: "Cash Ledger",
    path: "/admin/cash-ledger",
    color: "#bff1db",
    icon: "fa-solid fa-money-bill-wave",
    permission: "view_cash_ledger",
  },
  {
    name: "Teachers",
    path: "/admin/teachers",
    color: "#f2c4c4",
    icon: "fa-solid fa-chalkboard-user",
    permission: "view_teachers",
  },
  {
    name: "Grades",
    path: "/admin/grades",
    color: "#f9e1be",
    icon: "fa-solid fa-award",
    permission: "view_grades",
  },
  {
    name: "Sessions",
    path: "/admin/sessions",
    color: "#bff1db",
    icon: "fa-solid fa-calendar-days",
    permission: "view_sessions",
  },
  {
    name: "Subjects",
    path: "/admin/subjects",
    color: "#d5d1fd",
    icon: "fa-solid fa-layer-group",
    permission: "view_subjects",
  },
  {
    name: "Admins",
    path: "/admin/admins",
    color: "#f2c4c4",
    icon: "fa-solid fa-user-shield",
    permission: "view_admins",
  },
  {
    name: "Role Permissions",
    path: "/admin/role-permissions",
    color: "#f9e1be",
    icon: "fa-solid fa-lock",
    permission: "view_role_permissions",
  },
  {
    name: "Lectures",
    path: "/admin/lectures",
    color: "#bff1db",
    icon: "fa-solid fa-chalkboard",
    permission: "view_lectures",
  },
  {
    name: "Notes",
    path: "/admin/notes",
    color: "#d5d1fd",
    icon: "fa-solid fa-note-sticky",
    permission: "view_notes",
  },
  {
    name: "Worksheets",
    path: "/admin/worksheets",
    color: "#f2c4c4",
    icon: "fa-solid fa-file-lines",
    permission: "view_worksheets",
  },
  {
    name: "Bug Reports",
    path: "/admin/bug-reports",
    color: "#f2c4c4",
    icon: "fa-solid fa-bug",
    permission: "view_bug_reports",
  },
];

export const STUDENT_NAV_OPTIONS = [
  {
    name: "Explore",
    path: "/explore",
    permission: "view_self_learning",
  },
  {
    name: "All Courses",
    path: "/registercourse",
    permission: "view_register_courses",
  },
  {
    name: "My Courses",
    path: "/mycourses",
    permission: "view_my_courses",
  },
];

export const STUDENT_HOME_CONTROLS = [
  {
    name: "LECTURES",
    path: "/lectures",
    color: "#f2c4c4",
    permission: "view_class_lectures",
  },
  {
    name: "NOTES",
    path: "/notes",
    color: "#f9e1be",
    permission: "view_class_notes",
  },
  {
    name: "WORKSHEETS",
    path: "/worksheets",
    color: "#bff1db",
    permission: "view_class_worksheets",
  },
  {
    name: "REGISTRATION",
    path: "/registercourse",
    color: "#d5d1fd",
    permission: "view_register_courses",
  },
];

export const filterNavByPermission = (
  options,
  permissions,
  { isSuperAdmin = false } = {},
) => {
  if (isSuperAdmin) return options;
  const userPerms = Array.isArray(permissions) ? permissions : [];
  return options.filter((option) => userPerms.includes(option.permission));
};

export const filterAdminNavOptions = (
  permissions,
  { isSuperAdmin = false, options = ADMIN_NAV_OPTIONS } = {},
) => filterNavByPermission(options, permissions, { isSuperAdmin });
